import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import { useCart } from '../context/CartContext';
import { formatCurrency, formatCurrencyShort } from '../utils/currency';
import { BRAND } from '../data/brand';

export default function ShopCart() {
  const { cartItems, removeFromCart, updateQty, cartTotal } = useCart();
  const tax   = cartTotal * 0.08;
  const total = cartTotal + tax;

  if (cartItems.length === 0) return (
    <div className="page-wrapper">
      <Preloader /><Header />
      <PageTitle title="Cart" breadcrumbs={[{ label:'Cart' }]} />
      <div style={{ textAlign:'center', padding:'80px 20px' }}>
        <i className="fas fa-cart-shopping" style={{ fontSize:64, color:'#ddd', display:'block', marginBottom:20 }}></i>
        <h3 style={{ fontFamily:'var(--gw-font-h,serif)', fontSize:28, marginBottom:10 }}>Your cart is empty</h3>
        <p style={{ color:'#777', marginBottom:24 }}>Browse our rooms or shop products to add items.</p>
        <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
          <Link to="/rooms" className="h2-btn-primary">Browse Rooms</Link>
          <Link to="/shop"  className="h2-btn-ghost">Go to Shop</Link>
        </div>
      </div>
      <Footer /><ScrollToTop />
    </div>
  );

  return (
    <div className="page-wrapper">
      <Preloader /><Header />
      <PageTitle title="Your Cart" breadcrumbs={[{ label:'Cart' }]} />

      <section style={{ padding:'60px 0' }}>
        <div className="auto-container">
          <div className="row g-4">

            {/* Cart table */}
            <div className="col-lg-8">
              <div style={{ background:'#fff', border:'1px solid #e8e3dc', borderRadius:6, overflow:'hidden' }}>
                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                  <thead>
                    <tr style={{ background:'#111827' }}>
                      {['Item','Type','Price','Qty','Subtotal',''].map((h,i) => (
                        <th key={i} style={{ padding:'13px 16px', textAlign:'left', color:'#fff', fontSize:11, fontWeight:700, letterSpacing:1.5, textTransform:'uppercase' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {cartItems.map(item => (
                      <tr key={`${item.id}-${item.type}`} style={{ borderBottom:'1px solid #f0f0f0' }}>
                        <td style={{ padding:'14px 16px' }}>
                          <div style={{ fontWeight:600, fontSize:14, color:'#111' }}>{item.title}</div>
                        </td>
                        <td style={{ padding:'14px 16px' }}>
                          <span style={{ fontSize:11, padding:'3px 9px', borderRadius:2, background: item.type==='room'?'rgba(176,141,87,0.12)':'rgba(26,26,46,0.08)', color: item.type==='room'?'#b08d57':'#333', fontWeight:700 }}>
                            {item.type==='room'?'🏨 Room':'📦 Product'}
                          </span>
                        </td>
                        <td style={{ padding:'14px 16px', fontSize:14, color:'#555' }}>{formatCurrencyShort(item.price)}</td>
                        <td style={{ padding:'14px 16px' }}>
                          <div style={{ display:'flex', alignItems:'center', border:'1.5px solid #e8e3dc', borderRadius:3, overflow:'hidden', width:'fit-content' }}>
                            <button onClick={() => updateQty(item.id, item.type, item.qty-1)} style={{ width:30, height:32, background:'#f9f8f6', border:'none', cursor:'pointer', fontSize:14 }}>−</button>
                            <span style={{ width:36, textAlign:'center', fontSize:14, fontWeight:600, borderLeft:'1.5px solid #e8e3dc', borderRight:'1.5px solid #e8e3dc', lineHeight:'32px' }}>{item.qty}</span>
                            <button onClick={() => updateQty(item.id, item.type, item.qty+1)} style={{ width:30, height:32, background:'#f9f8f6', border:'none', cursor:'pointer', fontSize:14 }}>+</button>
                          </div>
                        </td>
                        <td style={{ padding:'14px 16px', fontWeight:700, fontSize:14, color:'#b08d57' }}>
                          {formatCurrency(item.price * item.qty)}
                        </td>
                        <td style={{ padding:'14px 16px' }}>
                          <button onClick={() => removeFromCart(item.id, item.type)}
                            style={{ width:28, height:28, border:'1px solid #ffcdd2', background:'#fff0f0', color:'#e53935', borderRadius:'50%', cursor:'pointer', fontSize:12, display:'flex', alignItems:'center', justifyContent:'center' }}>
                            <i className="fas fa-times"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ marginTop:14 }}>
                <Link to="/rooms" style={{ fontSize:13, color:'#777', textDecoration:'none', display:'inline-flex', alignItems:'center', gap:6 }}>
                  <i className="fas fa-arrow-left" style={{ fontSize:11 }}></i> Continue Browsing
                </Link>
              </div>
            </div>

            {/* Summary */}
            <div className="col-lg-4">
              <div style={{ background:'#f9f8f6', border:'1px solid #e8e3dc', borderRadius:6, padding:'26px 24px' }}>
                <h5 style={{ fontFamily:'var(--gw-font-h,serif)', fontSize:22, color:'#111', marginBottom:20, paddingBottom:14, borderBottom:'1px solid #e8e3dc' }}>Order Summary</h5>
                {[
                  ['Subtotal', formatCurrency(cartTotal)],
                  ['Tax (8%)', formatCurrency(tax)],
                  ['Shipping', 'Free'],
                ].map(([k,v],i) => (
                  <div key={i} style={{ display:'flex', justifyContent:'space-between', fontSize:14, color:'#666', marginBottom:10 }}>
                    <span>{k}</span>
                    <span style={{ color: v==='Free'?'#25d366':undefined, fontWeight: v==='Free'?600:400 }}>{v}</span>
                  </div>
                ))}
                <div style={{ display:'flex', justifyContent:'space-between', fontWeight:700, fontSize:18, color:'#111', borderTop:'1.5px solid #e8e3dc', paddingTop:14, marginBottom:22 }}>
                  <span>Total</span>
                  <span style={{ color:'#b08d57', fontFamily:'var(--gw-font-h,serif)' }}>{formatCurrency(total)}</span>
                </div>
                <Link to="/checkout" className="h2-btn-primary" style={{ display:'block', textAlign:'center', width:'100%' }}>
                  Proceed to Checkout
                </Link>
                <p style={{ fontSize:12, color:'#aaa', textAlign:'center', marginTop:12, display:'flex', alignItems:'center', justifyContent:'center', gap:5 }}>
                  <i className="fas fa-lock" style={{ color:'#25d366' }}></i> Payment via Bank Transfer — {BRAND.bank.bank}
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer /><ScrollToTop />
    </div>
  );
}
